import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface AccessAttemptData {
  user_id?: string;
  page_attempted: string;
  access_granted: boolean;
  ip_address?: string;
  user_agent?: string;
}

export const useAccessAttemptLogger = () => {
  const logAccessAttempt = async (attemptData: AccessAttemptData) => {
    try {
      // Get user agent from browser
      const userAgent = navigator.userAgent;
      
      const { error } = await supabase
        .from('admin_access_attempts')
        .insert([{
          user_id: attemptData.user_id || null,
          page_attempted: attemptData.page_attempted,
          access_granted: attemptData.access_granted,
          user_agent: userAgent,
          attempted_at: new Date().toISOString()
        }]);

      if (error) {
        console.error('Failed to log access attempt:', error);
      }
    } catch (error) {
      console.error('Error logging access attempt:', error);
    }
  };

  return { logAccessAttempt };
};